import React from 'react'
import Nav from './Nav'

function Notfound() {
  return (
    <div className='App'>
        <Nav></Nav>
         <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  )
}

export default Notfound